import React from 'react';

import { IconProps } from './types';

/** A two-tier birthday cake with one candle. Filled, one colour. */
export const CakeIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M12 1.5C12.95 2.62 13.5 3.45 13.5 4.15C13.5 4.98 12.83 5.65 12 5.65C11.17 5.65 10.5 4.98 10.5 4.15C10.5 3.45 11.05 2.62 12 1.5Z"
          fill={color}
        />
        <rect fill={color} height="3.25" rx="0.75" width="1.5" x="11.25" y="6.5" />
        <rect fill={color} height="5" rx="1.5" width="13" x="5.5" y="10" />
        <rect fill={color} height="6" rx="1.75" width="17" x="3.5" y="16" />
      </svg>
    );
  },
);
